<template>
  <ion-card mode="ios">
    <ion-card-header>
      <slide-y-up-transition :duration="700">
        <h6 v-show="show" class="text-up m-0">{{ title ? title : 'Umowa' }}</h6>
      </slide-y-up-transition>
    </ion-card-header>
    <ion-card-content style="padding-top: 0">
      <slide-x-left-transition :duration="400">
        <div v-if="show">
          <p class="pulse-status" v-if="active">
            <span class="dot" title="Trwa"></span>
            <span class="dot-text">Aktywna umowa w Programie Lojalnościowym</span>
          </p>
          <p class="pulse-status disabled"  v-if="!active && status">
            <span class="dot" title="Czeka"></span>
            <span class="dot-text">Niepotwierdzona umowa</span>
          </p>
        </div>
      </slide-x-left-transition>
      <slide-x-left-transition :duration="500">
        <ion-item v-if="show">
          <ion-thumbnail slot="start">
            <svg class="icon icon-document" style="font-size: 2rem; color: #c09a53">
              <use xlink:href="#icon-document"></use>
            </svg>
          </ion-thumbnail>
          <ion-label>
            <p><strong>Lokal:</strong> {{ place_name }}</p>
            <p><strong>Marka:</strong> {{ brand }}</p>
          </ion-label>
        </ion-item>
      </slide-x-left-transition>
      <div v-if="active">
        <ion-button  mode="ios"
                     fill="outline"
                     size="small"
                     @click="downloadFile"
                     class="mt-10">Pobierz umowę
        </ion-button>
        <ion-button v-if="canRemove"
                    mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo('LoyaltyTerminate')"
                    class="mt-10">Wypowiedz umowę
        </ion-button>
      </div>
      <div v-if="!active && status && canConfirm">
        <ion-button  mode="ios"
                     fill="outline"
                     size="small"
                     @click="openPopover"
                     class="mt-10">Potwierdź umowę
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import {mapGetters} from 'vuex';
  import goTo from '@/mixins/goto';
  import ConfirmTokenPopover from '@/popovers/ConfirmTokenPopover.vue';
  import Save from '@/services/Save';

  export default {
    name: 'CardLoyaltyContract',
    props: ['title','active','status','place_name','brand','uuid','canRemove','canConfirm'],
    mixins: [goTo],
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile'])
    },
    mounted() {
      this.show = true
    },
    methods: {
      downloadFile() {
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_FILE_REQUEST', this.uuid)
            .then(resp => {
              Save.file(resp, "umowa.pdf", {type: "application/pdf"})
            })
      },
      openPopover(){
        return this.$ionic.popoverController.create({
          component: ConfirmTokenPopover,
          mode: 'ios',
          componentProps: {
            propsData: {
              store: this.$store, // ionic bug:
              route: this.$route, // https://github.com/ModusCreateOrg/ionic-vue/issues/38#issuecomment-428247908
              uuid: this.uuid,
              ph_slug: this.getProfile.slug
            },
          },
        }).then(m => m.present())
      },
    }
  }
</script>

<style lang="scss" scoped>
  ion-card{
    margin: 15px 0;
    background: #fff;
  }
</style>